module Client.Admin.UnlockUser.Grid

open Shared
open Client
open Client.Admin
open Elmish
open Illy.SafeStack.Client 
open Illy.SafeStack.Client.jQueryUI
open Fable.React
open Shared.Admin
open SafeStack.Client

type Model =
    {
        Grid: UserGrid.Model
        Edit: Edit.Model option
    }

type Msg =
    | UserGridMsg of UserGrid.Msg
    | EditMsg of Edit.Msg
    | UnlockUser of UserId
    | NotificationWasHidden

type Event =
    | ApiError of ApiError
    | CloseOverlay

let init () =
    let m, c = UserGrid.init {UserGrid.IncludeUsersFilter.all with Unlocked = false; Disabled = false}
    {
        Grid = m
        Edit = None
    }, Cmd.map UserGridMsg c

let dispatchEditMsg model msg =
    match model.Edit with 
    | None -> model, SideEffect.none
    | Some edit ->
        let m, eff = Edit.update msg edit
        match eff with
        | SideEffect.Cmd c -> {model with Edit = Some m}, Cmd.map EditMsg c |> SideEffect.Cmd
        | SideEffect.Event ev ->
            match ev with
            | Edit.Event.ApiError err ->
                {model with Edit = Some m}, err |> ApiError |> SideEffect.Event
            | Edit.Event.CloseOverlay ->
                {model with Edit = None}, SideEffect.none
            | Edit.Event.SaveSuccessful notification ->
                {model with Edit = None},
                Cmd.batch [
                    Notification.success notification NotificationWasHidden
                    Cmd.ofMsg (UserGrid.Msg.RefreshGrid |> UserGridMsg)
                ] |> SideEffect.Cmd

let update msg (model: Model) =
    match msg with
    | UserGridMsg uMsg ->
        let m, eff = UserGrid.update uMsg model.Grid
        {model with Grid = m},
        match eff with 
        | SideEffect.Cmd c -> Cmd.map UserGridMsg c |> SideEffect.Cmd
        | SideEffect.Event ev ->
            match ev with
            | UserGrid.Event.ApiError err -> err |> ApiError |> SideEffect.Event
            | UserGrid.Event.CloseOverlay -> CloseOverlay |> SideEffect.Event
    | UnlockUser uId ->
        let m, c = Edit.init uId
        {model with Edit = Some m}, Cmd.map EditMsg c |> SideEffect.Cmd
    | EditMsg eMsg -> dispatchEditMsg model eMsg
    | NotificationWasHidden -> model, SideEffect.none

let view (model: Model) dispatch =
    [
        if model.Edit.IsNone then 
            yield! UserGrid.viewModal "Unlock User Accounts" model.Grid (UserGridMsg >> dispatch) [
                UserGrid.GridColumn.nameWithTooltip
                    (UserGrid.isLoadingMoreResults model.Grid)
                    model.Grid.SortInfo
                    (UserGridMsg >> dispatch)
                    (fun x -> x.LockedReason)
                UserGrid.GridColumn.username (UserGrid.isLoadingMoreResults model.Grid) model.Grid.SortInfo (UserGridMsg >> dispatch)
                Some [ str "Actions" ] ===> fun u -> [ UI.button "Unlock" (UnlockUser (UserId u.Id)) dispatch ]
            ]
        yield! jQueryUI.conditionallyRenderView model.Edit Edit.view EditMsg dispatch
    ]